import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { confirmDialog, toast } from '../../components/notifications/notificationService';
import Sidebar from '../../components/Sidebar/sidebar';
import Header from '../../components/Header';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';
import './posList.css';
import { API_BASE_URL } from '../../utils/apiBase';

const ListPOS = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [posList, setPosList] = useState([]);
    const [filteredPOS, setFilteredPOS] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 5; // show 5 POS per page
    const [selectedPOS, setSelectedPOS] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editData, setEditData] = useState({});
    const [fullImageUrl, setFullImageUrl] = useState(null);



    const openPOSDetails = (pos) => {
        setSelectedPOS(pos);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const enableEditMode = () => {
        setEditMode(true);
        setEditData(selectedPOS); // Pre-fill data
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditData({ ...editData, [name]: value });
    };

    const saveEditChanges = async () => {
        try {
            await axios.put(`${API_BASE_URL}/api/pos/updatePos/${selectedPOS._id}`, editData);
            alert('POS details updated successfully!');
            setEditMode(false);
            setShowModal(false);
            fetchPOSData(); // Reload list after update
        } catch (error) {
            console.error('Error updating POS details:', error);
            alert('Error updating POS.');
        }
    };

    const enlargePhoto = (id) => {
        setFullImageUrl(`${API_BASE_URL}/api/pos/photo/${id}`);
    };
    const closeEnlargedPhoto = () => {
        setFullImageUrl(null);
    };



    useEffect(() => {
        fetchPOSData();
    }, []);

    const fetchPOSData = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/pos/allPos`);
            setPosList(response.data);
            setFilteredPOS(response.data);
        } catch (error) {
            console.error('Error fetching POS data:', error);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);

        const filtered = posList.filter(pos =>
            pos.posName.toLowerCase().includes(value) ||
            pos.posCity.toLowerCase().includes(value) ||
            pos.posId.toLowerCase().includes(value)
        );

        setFilteredPOS(filtered);
        setCurrentPage(1); // Reset to first page after search
    };

    // Pagination logic
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = filteredPOS.slice(indexOfFirstEntry, indexOfLastEntry);

    const totalPages = Math.ceil(filteredPOS.length / entriesPerPage);

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    if (!isAuthenticated()) {
        return <Navigate to="/" />;
    }

    const handleDeletePOS = async () => {
        const confirmed = await confirmDialog({ title: `Delete ${selectedPOS.posId}?`, message: 'This POS record will be permanently removed.', confirmText: 'Delete POS' });
        if (!confirmed) return;
        try {
            await axios.delete(`${API_BASE_URL}/api/pos/deletePos/${selectedPOS._id}`);
            toast.success('POS has been deleted.');
            setShowModal(false);
            fetchPOSData();
        } catch (error) {
            console.error('Error deleting POS:', error);
            toast.error('Failed to delete POS.');
        }
    };
        
    

    return (
        <div className='POS-container'>
            <div className='sidebar'>
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            </div>
            <div className={`POS-content ${collapsed ? 'collapsed' : ''}`}>
                <Header />
                <section>
                    <h2>All POS Entries</h2>

                    <input
                        type="text"
                        placeholder="Search by Name, City, POS ID..."
                        value={searchTerm}
                        onChange={handleSearch}
                        className="search-bar"
                    />

                    <table className="pos-table">
                        <thead>
                            <tr>
                                <th>Profile Picture</th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Email</th>
                                <th>Pin Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentEntries.length > 0 ? (
                                currentEntries.map((pos) => (
                                    <tr key={pos._id}>
                                        <td>
                                            {pos.posProfile ? (
                                                <img src={`${API_BASE_URL}/api/pos/photo/${pos._id}`} alt="Profile" width="50" height="50" />

                                            ) : (
                                                'No Image'
                                            )}
                                        </td>
                                        <td>{pos.posName}</td>
                                        <td>{pos.posPhoneNumber}</td>
                                        <td>{pos.posEmail}</td>
                                        <td>{pos.posPinCode}</td>

                                        <td>
                                            <button onClick={() => openPOSDetails(pos)}>View</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="8">No POS entries found</td></tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination controls */}
                    <div className="pagination-controls">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                            Previous
                        </button>
                        <span> Page {currentPage} of {totalPages} </span>
                        <button onClick={goToNextPage} disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                </section>

                {showModal && selectedPOS && (
                    <div className="modal">
                        <div className="modal-content">
                            <h3>POS Details - {selectedPOS.posId}</h3>

                            {editMode ? (
                                <>
                                    <input type="text" name="posName" value={editData.posName} onChange={handleEditChange} />
                                    <input type="text" name="posPhoneNumber" value={editData.posPhoneNumber} onChange={handleEditChange} />
                                    <input type="email" name="posEmail" value={editData.posEmail} onChange={handleEditChange} />
                                    <input type="text" name="posAddress" value={editData.posAddress} onChange={handleEditChange} />
                                    <input type="text" name="posCity" value={editData.posCity} onChange={handleEditChange} />
                                    <input type="text" name="posState" value={editData.posState} onChange={handleEditChange} />
                                    <input type="text" name="posPinCode" value={editData.posPinCode} onChange={handleEditChange} />
                                    <button onClick={saveEditChanges}>Save Changes</button>
                                    <button onClick={() => setEditMode(false)}>Cancel</button>
                                </>
                            ) : (
                                <>
                                    <p><strong>Name:</strong> {selectedPOS.posName}</p>
                                    <p><strong>Phone:</strong> {selectedPOS.posPhoneNumber}</p>
                                    <p><strong>Email:</strong> {selectedPOS.posEmail}</p>
                                    <p><strong>Address:</strong> {selectedPOS.posAddress}</p>
                                    <p><strong>City:</strong> {selectedPOS.posCity}</p>
                                    <p><strong>State:</strong> {selectedPOS.posState}</p>
                                    <p><strong>Pin Code:</strong> {selectedPOS.posPinCode}</p>
                                    <p><strong>Profile:</strong><br />
                                        {selectedPOS.posProfile ? (
                                            <img
                                                src={`${API_BASE_URL}/api/pos/photo/${selectedPOS._id}`}
                                                alt="Profile"
                                                width="100"
                                                onClick={() => enlargePhoto(selectedPOS._id)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        ) : 'No Image'}
                                    </p>
                                    <button onClick={enableEditMode}>Edit</button>
                                    <button onClick={closeModal}>Close</button>
                                    <button onClick={handleDeletePOS} style={{ backgroundColor: 'red', color: 'white' }}>
                                        Delete
                                    </button>

                                </>
                            )}
                        </div>
                    </div>
                )}

                {fullImageUrl && (
                    <div className="modal" onClick={closeEnlargedPhoto}>
                        <div className="modal-content">
                            <img src={fullImageUrl} alt="Enlarged Profile" style={{ width: '100%', height: 'auto' }} />
                        </div>
                    </div>
                )}



            </div>
        </div>
    );
};

export default ListPOS;
